import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthorizationService, LogService, TranslationService } from '@mirage-projects/cw-commons';
import { TokenResponseData } from '@mirage-projects/cw-models';
import { UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

import { AppSharedService } from './app-shared.service';

/** This is the root component for Embed application */
@Component({
    selector: 'cw-root',
    templateUrl: './app-embed.component.html',
    standalone: false,
})
export class AppEmbedComponent implements OnInit {
    projectId!: number;
    code!: string;
    errorCode!: string;

    constructor(
        public appSharedService: AppSharedService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private authorizationService: AuthorizationService,
        private logService: LogService,
        private translationService: TranslationService,
        private utilsPcvizService: UtilsPcvizService
    ) {}

    ngOnInit(): void {
        this.appSharedService.init(this.changeDetectorRef);
        this.activatedRoute.queryParams.subscribe((params) => {
            this.projectId = params['project'];
            this.code = params['code'];
            this.loginForEmbed();
        });
    }

    get showContent(): boolean {
        return this.appSharedService.isUserLogged;
    }

    private loginForEmbed(): void {
        if (!this.code || !this.projectId) {
            return;
        }
        this.authorizationService.setAnonymousProject(this.projectId);
        this.authorizationService.getTokenByCode(this.code).subscribe({
            next: (tokenResponseData: TokenResponseData) => {
                this.authorizationService.setCapabilities(tokenResponseData.capabilities);
                const tokenUser = tokenResponseData.user;
                const tokenResponse = tokenResponseData.access_token;
                if (tokenResponse) {
                    this.authorizationService.setToken(tokenResponse);
                }

                if (tokenUser) {
                    const user = this.authorizationService.tokenUserToUser(tokenUser);
                    this.authorizationService.setCurrentUser(user);
                    this.appSharedService.setUserLogged(user);
                    this.utilsPcvizService.getMagnetApi().setAnonymous(true);
                }
            },
            error: (error: any) => {
                this.appSharedService.hideLoading();
                this.errorCode = error?.data?.code ?? `ERROR_${error.status}`;
                const errorMsg = this.translationService.translate(`MAGNET.${this.errorCode}`);
                this.logService.error(errorMsg);
            },
        });
    }
}
